import { render, staticRenderFns } from "./Address_add.vue?vue&type=template&id=c5aacae6&scoped=true"
import script from "./Address_add.vue?vue&type=script&lang=js"
export * from "./Address_add.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5aacae6",
  null
  
)

export default component.exports